(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1677],{

/***/ 38086:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-api/deployment-management",
      function () {
        return __webpack_require__(81252);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 81252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _src_landingPage_layouts_LayoutComponents_NextHead__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37672);
/* harmony import */ var _src_landingPage_views_DataApi_DataApi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43260);



var DataApiPage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_landingPage_layouts_LayoutComponents_NextHead__WEBPACK_IMPORTED_MODULE_1__/* .NextHead */ .B, {
                currentPath: "/data-api/deployment-management",
                title: "One Platform To Manage API Deployments",
                description: "Centrally manage all your third party data APIs with the Demyst platform."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_landingPage_views_DataApi_DataApi__WEBPACK_IMPORTED_MODULE_2__/* .DataApi */ .W, {
                keyword: "deployment-management"
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (DataApiPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,7232,9774,2888,179], function() { return __webpack_exec__(38086); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);